/**
 * Curtis XL heading: splits each .curtis-xl-heading into word spans and fades them in,
 * one after another, the first time the heading scrolls into view. The text that follows the
 * heading (its next siblings: subtext, intro, body, buttons) then fades in once the words land.
 */
(() => {
  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              entry.target.classList.add('is-in');
              entry.target.__xlFollowers?.forEach((el) => {
                el.classList.add('is-in');
                // Hand the element back to its own styles (hover transitions, transforms) once faded in
                const done = parseFloat(el.style.getPropertyValue('--follow-delay')) + 1200;
                setTimeout(() => el.classList.remove('curtis-xl-follow', 'is-in'), done);
              });
              observer.unobserve(entry.target);
            }
          },
          { threshold: 0.35, rootMargin: '0px 0px -8% 0px' },
        )
      : null;

  const prepare = (heading) => {
    if (heading.hasAttribute('data-xl-ready')) return;
    const words = heading.textContent.trim().split(/\s+/);
    heading.textContent = '';
    words.forEach((word, index) => {
      const span = document.createElement('span');
      span.className = 'curtis-xl-heading__word';
      span.style.setProperty('--word-index', index);
      span.textContent = word;
      heading.append(span);
      if (index < words.length - 1) heading.append(' ');
    });
    heading.setAttribute('data-xl-ready', '');

    // Followers start once the last word has begun to settle
    const followDelay = words.length * 110 + 250;
    heading.__xlFollowers = [];
    for (let el = heading.nextElementSibling; el; el = el.nextElementSibling) {
      el.classList.add('curtis-xl-follow');
      el.style.setProperty('--follow-delay', `${followDelay + heading.__xlFollowers.length * 120}ms`);
      heading.__xlFollowers.push(el);
    }
    if (observer) observer.observe(heading);
    else [heading, ...heading.__xlFollowers].forEach((el) => el.classList.add('is-in'));
  };

  const init = (root = document) => root.querySelectorAll('.curtis-xl-heading').forEach(prepare);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  // Theme editor re-renders sections in place
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
